export default __webpack_public_path__ + "static/PAPC_logo_green-dc9751929e119954ae9ea1864f4fac5c.png";